import React, { useEffect, useState } from 'react';

import useBrandChefsContext from 'contexts/brand-chefs.context';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
import ActivityIndicator from 'components/base/loader/activityIndicator';
import PrepItemMenu from 'pages/prep-team/kitchen-request/prep-item-menu';
import RequestStatusTag from 'components/base/request-status-tag';

const EditRequestForm = () => {
  const { activeRequest, setActiveRequest } = useBrandChefsContext();
  const [loading, setLoading] = useState(false);

  const [showDetails, setShowDetails] = useState<Record<number, boolean>>({});

  const getRequest = async () => {
    if (!activeRequest.id) return;
    setLoading(true);
    try {
      const res = await apiService.get(`prep-kitchen-request/${activeRequest.id}`, {
        version: 'v2'
      });
      setActiveRequest(res.data.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getRequest();
  }, []);

  const toggleDetails = (index: number) => {
    setShowDetails((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className=''>
      <div className=''>
        <div className='flex flex-col gap-1'>
          {loading ? (
            <div className='flex items-center justify-center w-full min-h-[200px]'>
              <ActivityIndicator />
            </div>
          ) : (
            activeRequest?.items?.map((data, index) => {
              const formattedStatus = data.status?.toUpperCase() as ENUM_REQUEST_STATUS;
              return (
                <div key={index}>
                  <div className='flex flex-col md:flex-row justify-between border-b border-b-[#EAEBEB] bg-[#F7F7F7E5] px-4 py-4 md:py-6 gap-4 md:gap-6 items-start md:items-center rounded'>
                    <div className='font-medium w-full md:w-auto text-sm'>
                      <div className='flex items-center md:gap-8 gap-2 mb-2'>
                        <p className=' font-semibold text-[#2E3031] capitalize'>
                          {data.ingredient.name}
                        </p>
                        <RequestStatusTag status={data.status} />
                      </div>
                      <div className='flex flex-wrap items-center gap-2 text-sm text-[#6F7376]'>
                        <p>
                          {data.quantity_requested} {data.item_type ?? 'prep'} requested
                        </p>
                      </div>
                    </div>
                    <div className='flex gap-3 w-full md:w-auto justify-end md:justify-start items-center'>
                      {data?.batches?.length === 0 ? (
                        <div className='flex justify-center h-64 items-center'>
                          <p> Oops, no items have been sent yet </p>
                        </div>
                      ) : (
                        [ENUM_REQUEST_STATUS.SENT].includes(formattedStatus) &&
                        activeRequest.status !== ENUM_REQUEST_STATUS.CANCELLED && (
                          <div className='p-1 rounded-full'>
                            <PrepItemMenu ids={data.id} status={formattedStatus} />
                          </div>
                        )
                      )}
                      <button
                        className='rounded-xl bg-white border px-2 py-1 font-medium text-[#5E6164] text-sm border-[#EAEBEB]'
                        onClick={() => toggleDetails(index)}>
                        {showDetails[index] ? 'Hide' : 'Show'}
                      </button>
                    </div>
                  </div>

                  {showDetails[index] && (
                    <ul className='flex flex-col gap-2 px-2 mt-2'>
                      {data.prep_item_ingredients.map((item, itemIndex) => (
                        <div key={itemIndex} className='flex gap-3 items-center'>
                          <p className='font-medium text-[#5E6164]'>{item.ingredient.name}</p>
                          <div className='bg-[#6F7376] w-1 h-1 rounded' />
                          <p className='font-normal text-sm text-[#6F7376]'>
                            {item.quantity_requested} {data.ingredient.unit_type} requested
                          </p>
                        </div>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default EditRequestForm;
